module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu_mypage/btn_my-page03-bb6782fce735718f40ce16cdc3a47dd4.png";